import utils from './utils'

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";

// https://github.com/verlok/vanilla-lazyload
import LazyLoad from 'vanilla-lazyload'

const dataAttrSuffix = 'timeline'
const dataAttr = 'data-' + dataAttrSuffix
const dataAttrItem = dataAttr + 'item'
let timelineInstances = []

const getAttributeObject = function(str='') {
  // jquery .data() requires a data-name='{"name": "value"}' pattern, not good for minification
  const dataString = str.replace(/'/g, '"')
  let obj = {}
  try {
    obj = JSON.parse(dataString)
  } catch (e) {
    console.log(e)
  } finally {
    return obj
  }
}

class Timeline {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)
    this.tl = null
    this.$items = []

    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.id = dataAttrSuffix + '-' + args.index
      this.$el.attr('id', this.id)
    }

    //this.$el.prepend('<div class="progress-bar-wrapper"><div class="progress-bar"></div></div>')
    //this.$progressBar = this.$el.find('.progress-bar')

    this.$items = this.$el.find('[' + dataAttrItem + ']')

    this.init()
  }

  preloadComplete() {
    this.setTimeline()
    this.$el.addClass('ready')
    window.app.$html.addClass('timeline-ready')
    //window.app.$html.removeClass('scroll-lock')
  }

  setTimeline() {
    this.tl = gsap.timeline()

    //gsap.utils.toArray("#" + this.id + " [d' + dataAttr + '-item]")
    //this.$items.forEach(layer => {
    this.$items.each((index, layer) => {
      const $layer = $(layer)
      //console.log(layer.dataset.timelineitem)
      let propsFrom = {opacity: 1}
      if($layer.attr(dataAttrItem)) {
        propsFrom = Object.assign({}, propsFrom, getAttributeObject($layer.attr(dataAttrItem)))
      }
      const duration = (propsFrom.hasOwnProperty("scaleX")) ? 1 : 1.5
      // https://greensock.com/docs/3
      const ease = (propsFrom.hasOwnProperty("scaleX")) ? 'elastic' : 'power2' // 'elastic'
      // https://greensock.com/docs/v3/GSAP/Timeline
      this.tl.fromTo(layer, propsFrom, {autoAlpha: 1, opacity: 1, scaleX: 1, scaleY: 1, x: 0, y: 0, ease: ease, duration: duration}, '>-0.5')
    })
  }

  scrollToTarget (e) {
    const $target = $(e.currentTarget) // e.target
    if ($target.attr('href')) {
      window.app.scrollTo($target.attr('href'), 0, 1000)
    }
  }

  init() {
    window.app.$html.addClass('scroll-lock')

    // https://github.com/verlok/vanilla-lazyload
    let loadedCount = 0
    const loadedCountTotal = this.$el.find('.layer-lazy').length
    this.lazyLoadInstance = new LazyLoad({
        callback_loaded: (el)=>{
          // this.lazyLoadInstance.loadingCount
          // this.lazyLoadInstance.toLoadCount
          loadedCount ++
          //this.$progressBar.width((loadedCount / loadedCountTotal * 100) + '%')
        },
        callback_finish: ()=>{
          setTimeout(()=>{
            this.preloadComplete()
          }, 100)
        },
        elements_selector: '#' + this.id + ' .layer-lazy'
    })
    this.lazyLoadInstance.loadAll()

    const _self = this
    // https://getbootstrap.com/docs/4.0/components/navs/#events
    this.$el.find('[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      window.app.$html.removeClass('scroll-lock')
      //e.target // newly activated tab
      //e.relatedTarget // previous active tab
      var hash = $(e.target).attr('href');
      if (history.pushState) {
        history.pushState(null, null, hash);
      } else {
        location.hash = hash;
      }
      _self.scrollToTarget(e)
    })
    this.$el.on('click', '[data-toggle="tab"].active', function (e) {
      window.app.$html.removeClass('scroll-lock')
      _self.scrollToTarget(e)
    })
    setTimeout(()=>{
      const hash = window.location.hash;
      if (hash) {
        $('[data-toggle="tab"][href="' + hash + '"]').click();
      }
    }, 600)
  }
  destroy() {
    if (this.tl) {
      this.tl.kill()
    }

    this.lazyLoadInstance.destroy()
  }
}

const init = function() {
  //if(window.app.isTouch()){
  $('[' + dataAttr + ']').each(function(index) {
    const spInstance = new Timeline(this, {index: index})
    timelineInstances.push(spInstance)
  })
}

const destroy = function() {
  //if(window.app.isTouch()){
  timelineInstances.forEach(spInstance => {
    spInstance.destroy()
  })
  timelineInstances = []
}

export default {init, destroy}
